import { Injectable } from '@angular/core';
import { LMToolbarServiceBase } from '@toolbar/lm-toolbar-service.base';
import { LMToolbarServiceAdapter } from '@toolbar/lm-toolbar-service-adapter';
import { LMConfigurationService, LMContextService } from '@app/services';

@Injectable()
export class LMBuilderToolbarService extends LMToolbarServiceBase {
    fakePageState: PageStateInfo = {
        isModified: false,
        selectedPanel: undefined
    };
    actionRefArray: Array<LMBusActionReference> | undefined;

    constructor(
        public lmToolbarServiceAdapter: LMToolbarServiceAdapter,
        public lmConfigurationService: LMConfigurationService,
        public lmContextService: LMContextService,
    ) {
        super(lmToolbarServiceAdapter); // must msg the base class constructor
    }

    public buildToolbar(mode: LMBuilderMode): void {
        this.actionRefArray = this.buildActionReferences(mode);
        this.updateToolbar();
    }

    public updateToolbar() {
        if (this.actionRefArray) {
            this.toolbarButtons = this.buildBuilderButtons(this.actionRefArray);
            this._updateToolbarState(this.toolbarButtons, this.fakePageState);
            this.fireToolbarObservable();
        }
    }

    private buildBuilderButtons(actionRefArray: LMBusActionReference[]): LMToolbarButton[] {
        return actionRefArray.map(actionRef =>
            // @ts-ignore
            this.buildLMToolbarButton(null, actionRef, true, false, false));
    }

    private _updateToolbarState(toolbarButtons: LMToolbarButton[], pageStateInfo: PageStateInfo) {
        // TODO
        // SHould i disable save and preview if there is an error
    }

    private buildActionReferences(mode: LMBuilderMode): Array<LMBusActionReference>  {

        return [
            {
                id: 'lm-builder-update-preview',
                automationId: 'lm-builder-update-preview',
                icon: 'refresh',
                label: Soho.Locale.translate('RefreshPreview'),
                type: 'standard',
            },
            {
                id: 'lm-builder-save',
                automationId: 'lm-builder-save',
                icon: 'save',
                label: Soho.Locale.translate('Save'),
                type: 'standard',
            },
            {
                id: 'lm-builder-save-view',
                automationId: 'lm-builder-save-view',
                icon: 'save',
                label: Soho.Locale.translate('SaveAndView'),
                type: 'standard',
            },
            {
                id: 'lm-builder-close',
                automationId: 'lm-builder-close',
                icon: 'close',
                label: Soho.Locale.translate('Close'),
                type: 'standard',
            },
        ];
     }
}